export default "/images/vendor/@coreui/icons/svg/flag/cif-bt.svg?3d7e26f6d8db1084e4446fcadc210fec";